function ErrorMessage({ message }: { message: string }) {
  return <p className="text-[#A80000] text-sm">{message}</p>;
}

export default ErrorMessage;
